import _ from "lodash";
/** External */
import React, { useEffect } from "react";
import { ToggleSwitch } from "@toddle-edu/ds-web";
import { compose, graphql } from "lib/apolloClient";

/** Internal */
import withLoader from "UIComponents/GqlWithLoader";
import { GRAPHQL_ONGOING_QUERY_NETWORK_STATUS } from "Constants";
import {
  getSnpSetWithCycleStatusQueryVariables,
  getSubTextFromCurriculumProgramType,
} from "InternalTools/modules/InternalToolUtils";
import { getInternalToolGenericDataQuery } from "InternalTools/modules/InternalToolsQuery";
import { getInternalToolGenericDataFromCache } from "InternalTools/modules/InternalToolsGraphqlHelper";

/** Relative */
import classes from "./SetList.scss";

const SetList = ({ data, sets, onUpdateSet, setSets, testId }) => {
  useEffect(() => {
    const setsData = _.omit(data, "isSuccess", []);
    setSets(setsData);
  }, [data]);

  const localTestId = `${testId}-setList`;

  return (
    <div
      className={classes.container}
      data-test-id={`${localTestId}-listOfSets`}
    >
      {_.map(sets, set => {
        const { setId, title, setEnabled } = set;
        return (
          <div key={setId} className={classes.setItem}>
            <div>
              {title} ({getSubTextFromCurriculumProgramType(set.curriculumUid)})
            </div>

            <ToggleSwitch
              onChange={() => onUpdateSet(setId)}
              checked={setEnabled}
              testId={`${localTestId}-listOfSets-${setId}-toggleSetSelection`}
            />
          </div>
        );
      })}
    </div>
  );
};

export default compose(
  graphql(getInternalToolGenericDataQuery, {
    name: "getSnpSets",
    options: ({ organizationId, curriculumProgramTypes }) => ({
      variables: getSnpSetWithCycleStatusQueryVariables({
        organizationId,
        curriculumUids: curriculumProgramTypes,
      }),
      fetchPolicy: "cache-and-network",
    }),
    props: ({ getSnpSets }) => {
      const internalToolsGenericData = getInternalToolGenericDataFromCache(
        getSnpSets.variables
      );

      return {
        isData: !_.isEmpty(internalToolsGenericData),
        isLoading: _.includes(
          GRAPHQL_ONGOING_QUERY_NETWORK_STATUS,
          getSnpSets.networkStatus
        ),
        data: _.get(internalToolsGenericData, "data"),
      };
    },
  }),
  withLoader
)(SetList);
